var map = {
	"./2011_Dec_C1.webp": 4377,
	"./2011_Dec_C2.webp": 7356,
	"./2013_Dec_C1.webp": 9415,
	"./2014_Dec_C1.webp": 8424,
	"./2014_Jul_C1.webp": 3677,
	"./2014_Nov_C1.webp": 8277,
	"./2014_Nov_C2.webp": 8520,
	"./2014_Sept_C1.webp": 6014,
	"./2015_Dec_C3.webp": 4739,
	"./2016_Nov_C1.webp": 1371,
	"./2018_Apr_C1.webp": 5287,
	"./2018_Dec_C1.webp": 2332,
	"./2018_Dec_C2.webp": 5369,
	"./2018_Feb_C1.webp": 5335,
	"./2018_Jan_C1.webp": 947,
	"./2018_May_C1.webp": 9579,
	"./2018_May_C2.webp": 7210,
	"./2018_Nov_C1.webp": 8785,
	"./2019_Dec_C1.webp": 7137,
	"./2019_Dec_C2.webp": 6500,
	"./2019_Dec_C3.webp": 199,
	"./2019_Dec_C4.webp": 714,
	"./2019_Dec_C5.webp": 2581,
	"./2019_Feb_C1.webp": 6218,
	"./2019_Jan_C1.webp": 9078,
	"./2019_Jun_C1.webp": 2226,
	"./2019_Nov_C1.webp": 9872,
	"./2019_Nov_C2.webp": 2957,
	"./2019_Nov_C3.webp": 9938,
	"./2019_Nov_C5.webp": 3740,
	"./2019_Oct_C1.webp": 3547,
	"./2019_Oct_C2.webp": 1821,
	"./2019_Sept_C1.webp": 4881,
	"./2020_Dec_C1.webp": 8449,
	"./2020_Dec_C2.webp": 1108,
	"./2020_Dec_C3.webp": 2967,
	"./2020_Jan_C1.webp": 9574,
	"./2020_Jan_C2.webp": 7,
	"./2020_Nov_C1.webp": 6544,
	"./2020_Nov_C2.webp": 9373,
	"./2021_Apr_C1.webp": 5671,
	"./2021_Dec_C2.webp": 6073,
	"./2021_Dec_C3.webp": 6350,
	"./2021_Jan_C1.webp": 1875,
	"./2021_Jul_C1.webp": 9009,
	"./2021_Jun_C1.webp": 2583,
	"./2021_Jun_C2.webp": 1558,
	"./2021_Jun_C4.webp": 264,
	"./2021_Mar_C1.webp": 5436,
	"./2021_Mar_C2.webp": 3401,
	"./2021_Mar_C3.webp": 7326,
	"./2021_Nov_C1.webp": 3777,
	"./2022_Dec_C1.webp": 9183,
	"./2022_Dec_C2.webp": 5838,
	"./2022_Dec_C3.webp": 5561,
	"./2022_Jan_C1.webp": 64,
	"./2022_Jun_C1.webp": 3436,
	"./2022_Jun_C2.webp": 1353,
	"./2022_Jun_C3.webp": 5326,
	"./2022_Jun_C4.webp": 6963,
	"./2023_Apr_A1.webp": 9311,
	"./2023_Feb_C1.webp": 4409,
	"./2023_Jan_C1.webp": 1381,
	"./2023_Jan_C2.webp": 2456,
	"./2023_Jun_C1.webp": 2801,
	"./2023_Oct_1.webp": 9127,
	"./2023_Oct_2.webp": 9862,
	"./2023_Oct_3.webp": 9617,
	"./2023_Oct_4.webp": 4344,
	"./2024_Nov_1.webp": 1959,
	"./2025_Dec_2.webp": 3730,
	"./2025_Dec_3.webp": 141,
	"./2025_Jun_10.webp": 3598,
	"./2025_Jun_3.webp": 6048,
	"./2025_Jun_4.webp": 6473,
	"./2025_Jun_5.webp": 6750,
	"./2025_Jun_6.webp": 95,
	"./2025_Jun_7.webp": 8508,
	"./2025_Jun_8.webp": 437,
	"./2026_Apr_3.webp": 2221,
	"./2026_Apr_4.webp": 5276,
	"./2026_Apr_5.webp": 159,
	"./2026_Apr_6.webp": 3518,
	"./2026_Apr_7.webp": 9545,
	"./2026_Apr_8.webp": 4104,
	"./DA-AE.webp": 5125,
	"./HNN.webp": 7277,
	"./LGAfford-NET.webp": 8230,
	"./NTIRE.webp": 9285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7567;